import React, { useState } from 'react';
import PageWrapper from '@components/common/layout/PageWrapper';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Card, Tabs } from 'antd';

import AppVersionFormModal from './AppVersionFormModal';
import AppVersionTable from './AppVersionTable';

const SERVICE_TABS = [
    { key: 'DPC', label: 'DPC', service: 'DPC', acceptedExtensions: '.apk' },
    { key: 'ORDERCON', label: 'ORDERCON', service: 'OrderCon', acceptedExtensions: '.apk' },
    { key: 'KITPLAY', label: 'KITPLAY', service: 'KitPlay', acceptedExtensions: '.apk' },
    { key: 'PI_SERVER', label: 'PI SERVER', service: 'PiServer', acceptedExtensions: '.gz' },
];

export default function AppManagementPage() {
    const translate = useTranslate();
    const [activeTab, setActiveTab] = useState(SERVICE_TABS[0].key);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tableRefreshKey, setTableRefreshKey] = useState(0);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleUploadSuccess = () => {
        setIsModalOpen(false);
        setTableRefreshKey((prev) => prev + 1);
    };

    const tabItems = SERVICE_TABS.map((tab) => ({
        key: tab.key,
        label: tab.label,
        children: (
            <AppVersionTable
                key={`${tab.key}-${tableRefreshKey}`}
                service={tab.service}
                onAdd={handleOpenModal}
            />
        ),
    }));

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const currentTab = SERVICE_TABS.find((tab) => tab.key === activeTab);

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.appManagement),
                },
            ]}
        >
            <Card
                title={null}
                bordered={false}
            >
                <Tabs activeKey={activeTab} onChange={handleTabChange} items={tabItems} destroyInactiveTabPane />
            </Card>

            <AppVersionFormModal
                open={isModalOpen}
                onClose={handleCloseModal}
                service={currentTab?.service}
                acceptedExtensions={currentTab?.acceptedExtensions}
                onSuccess={handleUploadSuccess}
            />
        </PageWrapper>
    );
}
